/**
 * PremiumTopBar — topo compartilhado do funil Premium (telas 5–8).
 *
 * Esquerda: botão de vidro 40 — X (fecha) ou ← (volta) quando `onVoltar`
 * existe. Direita: selo pílula "PREMIUM" (primary / onPrimary, 11/800,
 * tracking .12em).
 *
 * Fonte: handoffAnuncios/PROMPT-claude-code.md § Elementos comuns.
 */

import React from 'react';
import haptics from '../../design/feedback/haptics';
import s from './PremiumTopBar.module.scss';

export default function PremiumTopBar({ onFechar, onVoltar }) {
  const voltar = typeof onVoltar === 'function';
  const acao = voltar ? onVoltar : onFechar;

  const tocar = () => {
    haptics.light();
    acao?.();
  };

  return (
    <div className={s.barra}>
      {typeof acao === 'function' ? (
        <button
          type="button"
          className={s.botao}
          aria-label={voltar ? 'Voltar' : 'Fechar'}
          onClick={tocar}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {voltar ? <path d="M15 18l-6-6 6-6" /> : <path d="M18 6 6 18M6 6l12 12" />}
          </svg>
        </button>
      ) : (
        <span className={s.vazio} aria-hidden="true" />
      )}
      <span className={s.selo}>TURBO</span>
    </div>
  );
}
